// Manage Edit QA prospects settings
import { manageEditCampaignQAprospect, manageEditCampaignQAprospectConfig } from './manage.qaProspectSettings'

export default function manageEditQaProspectSettings($stateProvider) {
    'ngInject'
    $stateProvider.state(manageEditCampaignQAprospect, manageEditCampaignQAprospectConfig)
}